import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import Page from '../molecules/Page';
import api from '../../api/apiHelper';
import { MdArrowBack, MdPrivacyTip } from 'react-icons/md'; // Usunąłem import ikony pobierania

const TermsOfService = () => {
  const [policy, setPolicy] = useState({ version: '', content: '' });
  const [isLoading, setIsLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    const fetchPolicyContent = async () => {
      setIsLoading(true);
      try {
        const response = await api.get('/policies/latest/terms_of_service/');
        setPolicy(response.data);
        setError(null);
      } catch (err) {
        setError("Nie udało się załadować dokumentu. Spróbuj ponownie później.");
        console.error(err);
      } finally {
        setIsLoading(false);
      }
    };

    fetchPolicyContent();
  }, []);

  const renderContent = () => {
    if (isLoading) {
      return (
        <div className="flex justify-center items-center h-64">
           <p className="text-gray-500 font-apotek tracking-widest animate-pulse">ŁADOWANIE REGULAMINU...</p>
        </div>
      );
    }

    if (error) {
      return (
        <div className="text-center py-10">
          <p className="text-[#8A0000] font-bold mb-4">{error}</p>
          <button 
            onClick={() => window.location.reload()} 
            className="text-sm underline text-gray-600 hover:text-gray-800"
          >
            Spróbuj odświeżyć
          </button>
        </div>
      );
    }

    return (
      <>
        {/* NAGŁÓWEK */}
        <div className="flex flex-col md:flex-row md:items-end justify-between border-b border-gray-200 pb-6 mb-8 gap-4">
            <div>
                <h1 className="text-3xl lg:text-4xl font-bold text-[#233855] mb-2 font-apotek tracking-wide">
                  REGULAMIN SERWISU
                </h1>
                <p className="text-sm text-gray-500">
                  Obowiązuje wersja: <span className="font-semibold text-[#233855]">{policy.version}</span>
                </p>
            </div>

            {/* Przycisk do Polityki Prywatności (PDF usunięty) */}
            <Link 
                to="/privacy-policy"
                className="flex items-center gap-2 text-sm font-medium text-[#233855] bg-gray-100 hover:bg-gray-200 px-4 py-2 rounded-lg transition-colors whitespace-nowrap"
            >
                <MdPrivacyTip className="text-lg" />
                Polityka Prywatności
            </Link>
        </div>
        
        {/* TREŚĆ HTML Z API */}
        <div 
          className="prose prose-lg max-w-none text-gray-700 prose-headings:text-[#233855] prose-headings:font-bold prose-a:text-blue-600 prose-strong:text-[#233855] policy-fix-counters" 
          dangerouslySetInnerHTML={{ __html: policy.content }}
        />
      </>
    );
  };

  return (
    <Page showNav={false}>
      <div className="flex flex-col items-center w-full px-4 lg:px-0 pb-10">
        
        {/* BIAŁY BOX */}
        <div className="bg-white rounded-xl lg:rounded-[3rem] shadow-[4px_4px_12px_rgba(0,0,0,0.30)] border border-gray-200 w-full max-w-5xl px-6 lg:px-16 py-8 lg:py-14 mt-[3vh] lg:mt-[5vh]">
          
          {renderContent()}

          {/* STOPKA Z POWROTEM */}
          <div className="mt-12 pt-8 border-t border-gray-200 flex flex-col sm:flex-row justify-between items-center gap-4">
            <Link 
              to="/" 
              className="group flex items-center gap-2 px-6 py-3 text-sm font-apotek tracking-widest rounded-lg bg-[#233855] text-white hover:bg-[#345081] shadow-md transition-all"
            >
              <MdArrowBack className="group-hover:-translate-x-1 transition-transform" />
              WRÓĆ DO STRONY GŁÓWNEJ
            </Link>
          </div>

        </div>
        
        <div className="h-[5vh]" />
      </div>
    </Page>
  );
};

export default TermsOfService;